import { render, staticRenderFns } from "./SourEditAppr.vue?vue&type=template&id=2a0e453b&scoped=true&"
import script from "./SourEditAppr.vue?vue&type=script&lang=js&"
export * from "./SourEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0e453b",
  null
  
)

export default component.exports